"use strict";

export { Wrap } from '../../../handlers/gestures/GestureDetector/Wrap';
//# sourceMappingURL=Wrap.web.js.map